const translations = {
    clear: 'Clear',
    reset: 'Reset'
};

export default translations;
